const AZ_NORMALIZE_MAP: Record<string, string> = {
  ə: 'e',
  ı: 'i',
  ö: 'o',
  ü: 'u',
  ç: 'c',
  ğ: 'g',
  ş: 's',
};

export function normalizeForCompare(value: string) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[əıöüçğş]/g, (char) => AZ_NORMALIZE_MAP[char] || char)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\u0307/g, '')
    .replace(/\s+/g, ' ');
}
